import React from 'react';
import { Section } from './ui/Section';
import { AlertTriangle, ArrowRight } from 'lucide-react';
export function ProblemReframe() {
  return <Section className="bg-[#0f0f0f]" data-id="element-206">
      <div className="max-w-3xl mx-auto text-center" data-id="element-207">
        <div className="inline-flex items-center justify-center p-3 bg-yellow-500/10 rounded-full mb-8" data-id="element-208">
          <AlertTriangle className="w-8 h-8 text-yellow-500" data-id="element-209" />
        </div>

        <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-210">
          El problema real no es “estrés”. <br data-id="element-211" />
          <span className="text-gray-500" data-id="element-212">Es activación + reacción.</span>
        </h2>

        <div className="bg-[#1A1A1A] border border-gray-800 rounded-2xl p-8 md:p-10 text-left my-12 shadow-2xl" data-id="element-213">
          <h3 className="text-xl font-bold text-white mb-6 border-b border-gray-800 pb-4" data-id="element-214">
            Cuando tu activación está alta:
          </h3>
          <ul className="space-y-4" data-id="element-215">
            {['Te cuesta priorizar', 'Tu mente corre en loops', 'Buscas aliviarte (scroll, comida, discutir, evitar)', 'Haces lo fácil y postergas lo importante'].map((item, i) => <li key={i} className="flex items-center gap-4 text-gray-300" data-id="element-216">
                <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full" data-id="element-217" />
                {item}
              </li>)}
          </ul>
          <div className="mt-8 pt-6 border-t border-gray-800 text-center" data-id="element-218">
            <p className="text-xl font-medium text-white" data-id="element-219">
              Y así se te va el día.
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-xl md:text-2xl font-bold" data-id="element-220">
          <span className="text-gray-500 line-through decoration-red-500/50" data-id="element-221">
            No necesitas una filosofía.
          </span>
          <ArrowRight className="hidden md:block text-[#2563EB]" data-id="element-222" />
          <span className="text-[#2563EB]" data-id="element-223">
            Necesitas un reset en tiempo real.
          </span>
        </div>
      </div>
    </Section>;
}